export default {
  LINESHEET_DELETE_ASK: 'Are you sure you want to delete **%%**?',
  LINESHEET_DELETE_CONFIRM: 'Deleting **%%**',
  LINESHEET_LIMIT: 'You\'ve reached your current limit of **%% linesheets**. Please delete a linesheet to create a new one.',
  ERROR_LINESHEET_CREATE: 'We experienced an error while creating a new linesheet. Please try again.',
  ERROR_LINESHEET_DELETE: 'An error occurred deleting the linesheet. Please try again',
  ERROR_LINESHEET_LOAD: 'We experienced an error while loading your linesheet. Please reload this page and try again.',
  ERROR_LINESHEET_NOT_FOUND: 'We couldn\'t find the requested linesheet. Please ensure you have entered the correct URL or ensure the linesheet still exists.',
  ERROR_LINESHEET_SAVE: 'We experienced an error while saving your linesheet. Please try again.',
  ERROR_UPLOAD_FILETYPE_RESTRICT: 'You can only upload JPEG, PNG and SVG files',
  ERROR_UPLOAD_MAX_FILELIMIT: 'Only one image per product can be uploaded',
  ERROR_UPLOAD_MAX_FILESIZE: 'Each image must be smaller than 10MB',
  ERROR_UPLOAD_UNKNOWN_ERROR: 'An unexpected error occurred. Please try again.',
  PRODUCT_REMOVE_ASK: 'Are you sure you want to delete **%%**?',
  UNKNOWN_ERROR: 'An unexpected error occurred. Please try again.',
} as {
  [key: string]: string,
};
